<script setup>
const props = defineProps({
    selectedValue: {
        type: String,
        default: null,
    },
    dropdownId: {
        type: String,
        default: 'default-dropdown-id'
    },
    isDisabled: {
        type: Boolean,
        default: false,
    },
    sortedOptions: {
        type: Array,
        default: [],
    },
    placeholderLabel: {
        type: String,
        default: '',
    }
});
const emit = defineEmits(['onChange']);

const handleChange = (e) => {
    e.preventDefault();
    emit('onChange', e.target.value);
};
</script>
<template>
    <select :id="dropdownId" @change="handleChange"
        class="tw-text-[#00101D] tw-border-[#D1D5DB] dark:tw-border-[#445F74] tw-h-[42px] tw-rounded-[63px] tw-pt-[8px] tw-pb-[9px] tw-px-[13px] tw-text-[13px] sm:tw-text-[14px] tw-w-full dark:tw-bg-black tw-px-[14px] tw-box-border" :class="selectedValue ? 'dark:tw-text-white' : 'tw-text-[#52525A] dark:tw-text-[#9EC0DC]'" @keydown.prevent>
        <option :selected="!selectedValue" disabled :value="null">
            {{ placeholderLabel }}
        </option>
        <option v-for="option in sortedOptions"
                :key="option.value"
                :value="option.value"
                :selected="option.value === selectedValue"
                class="tw-text-black dark:tw-text-white"
        >
            {{ option.value }}
        </option>
    </select>
</template>
